import React from 'react';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { SplashScreen } from '@piwikpro/ui-components';

export const Route = createRootRoute({
  component: () => <Outlet />,
  notFoundComponent: () => <SplashScreen type="notFound" />,
});
